import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, LogOut, Menu, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { topNavItems } from '../mock';
import { useAuth } from '../context/AuthContext';
import { WORKSPACE_LABEL } from '../config/brand';
import { BrandLogo } from './Brand';

const UserMenu = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);
  if (!user) return null;
  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((v) => !v)} data-testid="user-menu-button" className="flex items-center gap-2 pl-2 pr-1 py-1 rounded-md hover:bg-[#F3F3FE] transition-colors">
        {user.picture ? (
          <img src={user.picture} alt="" className="w-8 h-8 rounded-full object-cover" referrerPolicy="no-referrer" />
        ) : (
          <div className="w-8 h-8 rounded-full bg-[#0A1551] text-white flex items-center justify-center text-[13px] font-bold">{(user.name || '?').charAt(0).toUpperCase()}</div>
        )}
        <span className="hidden md:block text-[14px] font-medium text-[#0A1551] max-w-[140px] truncate" data-testid="user-name">{user.name}</span>
        <ChevronDown className="w-4 h-4 text-[#6F76A7]" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 w-60 bg-white border border-[#E3E5F5] rounded-xl shadow-xl py-2 z-50">
          <div className="px-3 py-2 border-b border-[#E3E5F5]">
            <div className="text-[14px] font-semibold text-[#0A1551] truncate">{user.name}</div>
            <div className="text-[12px] text-[#6F76A7] truncate" data-testid="user-email">{user.email}</div>
          </div>
          <button onClick={logout} data-testid="logout-button" className="w-full flex items-center gap-2 px-3 py-2 text-[13px] text-[#0A1551] hover:bg-[#F5F6FB] text-left">
            <LogOut className="w-4 h-4" /> Log out
          </button>
        </div>
      )}
    </div>
  );
};

const TopBar = ({ onMenu }) => {
  const { user } = useAuth();
  return (
  <header className="h-[60px] bg-white border-b border-[#E3E5F5] flex items-center px-3 md:px-4 z-40 relative">
    <div className="flex items-center gap-2 md:gap-3 min-w-0">
      {onMenu && (
        <button onClick={onMenu} data-testid="sidebar-toggle" className="md:hidden p-2 -ml-1 rounded-md hover:bg-[#F3F3FE]" aria-label="Open menu">
          <Menu className="w-5 h-5 text-[#0A1551]" />
        </button>
      )}
      <Link to="/"><BrandLogo size="sm" /></Link>
      <div className="hidden sm:flex items-center gap-1.5 px-2 py-1.5 rounded-md">
        <span className="text-[15px] font-medium text-[#0A1551]">{WORKSPACE_LABEL}</span>
      </div>
    </div>
    <div className="ml-auto flex items-center gap-1">
      <nav className="hidden lg:flex items-center gap-1 mr-3">
        {topNavItems.map((item) => (
          <span key={item.name} className="flex items-center gap-1 px-3 py-2 text-[14px] font-medium text-[#0A1551]/60 cursor-default" title="Coming soon">
            {item.name}
            {item.hasDropdown && <ChevronDown className="w-3.5 h-3.5" />}
          </span>
        ))}
      </nav>
      {user?.is_admin && (
        <Link to="/admin" data-testid="topbar-admin-link" className="inline-flex items-center gap-1.5 px-2.5 py-1.5 mr-1 rounded-md bg-[#E6F4F2] text-[#0F766E] text-[13px] font-semibold hover:bg-[#D4EDEA]">
          <ShieldCheck className="w-4 h-4" /> <span className="hidden sm:inline">Admin</span>
        </Link>
      )}
      <UserMenu />
    </div>
  </header>
  );
};

export default TopBar;
